import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withTranslation, Trans } from 'react-i18next';
import withCustomComponent from 'ui/components/withCustomComponent';
import DefaultLayout from 'ui/layouts/DefaultLayout';
import { NoAccessNotice } from 'ui/components/NoAccessNotice';
import { checkTerms } from 'env/checkTerms';
import { routes } from 'env/routes';
import { withRouter } from 'next/router';

import BookingHeader from 'ui/_pages/bookings/components/BookingHeader';

import FloorPlanCanvas from 'ui/_pages/bookings/floorplan/FloorPlanCanvas';
import { FloorPlanItemFilters } from 'ui/_pages/bookings/floorplan/FloorPlanItemFilters';
import FloorPlanCart from 'ui/_pages/bookings/floorplan/FloorPlanBasket';
import { withAppWrapper, getServerSidePropsForAppWrapper} from 'ui/components/withAppWrapper';



@withAppWrapper()
@checkTerms
@withRouter
@withCustomComponent('FloorPlan')
@withTranslation()
@inject('appStore', 'authStore', 'floorPlanStore')
@observer
class FloorPlanById extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    const { t, appStore, floorPlanStore } = this.props;
    floorPlanStore
      .loadItems()
      .catch((err) => {
        this.setState({
          error: t('We could not load the floor plans at this time.'),
        });
      })
      .then(() => {
        this.loadFloorPlan();
      });
  }

  componentDidUpdate(prevProps, prevState) {
    const { router } = this.props;
    const prevQuery = prevProps.router.query;
    const currentQuery = router.query;
    if (JSON.stringify(currentQuery) != JSON.stringify(prevQuery)) {
      this.loadFloorPlan();
    }
  }

  componentWillUnmount() {
    const { floorPlanStore } = this.props;
    floorPlanStore.selectFloorPlan(null);
  }

  doSearch = () => {
    const { t, appStore, floorPlanStore } = this.props;
    floorPlanStore.loadItems().catch((err) => {
      this.setState({
        error: t('We could not load the floor plans at this time.'),
      });
    });
  };

  selectShift = (shiftId) => {
    const { floorPlanStore } = this.props;
    floorPlanStore.selectShift(shiftId);
  };

  selectDates = (dates) => {
    const { floorPlanStore } = this.props;
    floorPlanStore.selectDates(dates);
  };

  selectFloorPlan = (floorPlan) => {
    const { router } = this.props;
    router.push(
      routes.floorplan_by_id('[floorplan_id]'),
      routes.floorplan_by_id(floorPlan)
    );
  };

  loadFloorPlan() {
    const { floorPlanStore, router } = this.props;
    var foundPlan = floorPlanStore.floorPlans.find(
      (fp) => fp.floorPlan.Id == router.query.floorplan_id
    );

    if (foundPlan) floorPlanStore.selectFloorPlan(foundPlan?.floorPlan);
    else floorPlanStore.selectFloorPlan(null);
  }

  render() {
    const { t, floorPlanStore, appStore } = this.props;
    const { showTypeFilters, currentFloorPlan } = floorPlanStore;
    const { business } = appStore;
    const hasError = this.state.error != null;
    return (
      <DefaultLayout
        componentName={this.props.componentName}
        title={t('Floor plans - {{Name}}', { Name: business && business.Name })}
      >
        <main className="content content--custom" role="main">
          <div className="container">
            <BookingHeader
              isGrey
              doSearch={this.doSearch}
              selectShift={this.selectShift}
              selectDates={this.selectDates}
              shifts={floorPlanStore.shifts}
              isLoadingItems={floorPlanStore.isLoadingItems}
              shiftId={floorPlanStore.shiftId}
              fromTime={floorPlanStore.fromTime}
              toTime={floorPlanStore.toTime}
              hideResourceFilters={true}
            />

            <div className="floorplans">
              <FloorPlanItemFilters selectFloorPlan={this.selectFloorPlan} />
              <NoAccessNotice error={this.state.error} />
              <FloorPlanCanvas selectFloorPlan={this.selectFloorPlan} />
            </div>
          </div>
        </main>
      </DefaultLayout>
    );
  }
}

export default FloorPlanById;
